import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { PdfIcon24Regular } from "../../../../../icons2022/FileTypePdfIcon/PdfIcon24Regular";
import { PdfIcon32Regular } from "../../../../../icons2022/FileTypePdfIcon/PdfIcon32Regular";
import { PdfIcon64Regular } from "../../../../../icons2022/FileTypePdfIcon/PdfIcon64Regular";
export var PdfIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(PdfIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(PdfIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(PdfIcon64Regular, null);
  }
}, 'PdfIcon');